export const enum UAApps {
  StorageByUA = 'storage_by_unifyapps',
  CommentsByUnifyApps = 'comments_by_unifyapps',
  Callables = 'callables',
  AuthByUA = 'auth_by_unifyapps',
  CodeByUA = 'code_by_unifyapps',
  CustomHttpEndpoint = 'custom_http_endpoint',
  PlatformByUA = 'platform_by_unifyapps',
  StandardEntities = 'standard_entities',
  UtilityByUA = 'utility_by_unifyapps',
  CalendarByUA = 'calendar_by_unifyapps',
}

export const enum UAAppResources {
  CallablesReturnResponseToApi = 'callables_return_response_to_api',
  CodeByUAGroovy = 'code_by_unifyapps_groovy',
  CodeByUAJavaScript = 'code_by_unifyapps_javascript',
  CustomHttpEndpointExecute = 'custom_http_endpoint_execute',
  EDIToolsByUAGenerateEDI = 'edi_tools_by_unifyapps_generate_edi',
  StandardEntitiesCreateOrUpdateUserPreferences = 'standard_entities_create_or_update_user_preferences',
  StandardEntitiesFetchUserPreferences = 'standard_entities_fetch_user_preferences',
  UtilityByUADownloadFileAsString = 'utility_by_unifyapps_download_file_as_string',
}
